module.exports = __webpack_public_path__ + "static/media/eurasian_hunter_gatherers_icon_small.324c5655.png";